import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PrivateHealthStepParams } from './types'
import { employmentSchema } from './types'

export const employmentStatus = (params: PrivateHealthStepParams) => {
  const schema = employmentSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_privateHealth:steps.employment_status.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_private_health_de.shape.configuration_parameters.shape.employment_status.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_privateHealth:steps.employment_status.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('employment_status'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'income',
    subFlow: SubFlow.PrivateHealth,
  } as const satisfies AnyStepConfiguration
}
